import React from "react";
import { useTSContext } from "../../../context/Dashboard/contextTScore";
import { useThemeMode } from "../../../context/contextTheme";
import hexToRGBA from "../../../utils/hexToRGBA";
import "./style.css";

const BreachProbability = ({ score }) => {
  const { theme } = useThemeMode();
  const { hasScore, hasMisconfig } = useTSContext();
  const isValidScore = typeof score === "number" && score >= 0;

  const getColorScheme = (score = 0) => {
    if (score >= 8) {
      return {
        text: theme.labelTextDanger,
        bg: theme.labelBgDanger,
        line: theme.labelTextDanger
      };
    }

    if (score >= 5) {
      return {
        text: theme.labelTextWarning,
        bg: theme.labelBgWarning,
        line: theme.labelTextWarning
      };
    }

    if (score >= 1) {
      return {
        text: theme.labelTextSuccess,
        bg: theme.labelBgSuccess,
        line: theme.labelTextSuccess
      };
    }

    return {
      text: theme.labelTextMuted,
      bg: theme.labelBgMuted,
      line: theme.labelLineMuted
    };
  };

  const { text, bg, line } = getColorScheme(score);
  const renderScore = ({ showScore, score, emptyText, color }) => {
    if (showScore) {
      return (
        <h1 className="fw-bold display-6 mb-0" style={{ color }}>
          {score} <span className="h5"></span>
        </h1>
      );
    }

    return (
      <p className="small px-3" style={{ color }}>
        {emptyText}
      </p>
    );
  };

  return (
    <div className="p-2 pb-0 mb-3">
      <div
        className="card rounded-4 shadow-sm d-flex flex-row align-items-stretch"
        style={{
          minWidth: 200,
          width: 260,
          height: 110,
          backgroundColor: bg,
          border: `1px solid ${hexToRGBA(line, 1)}`,
          overflow: "hidden"
        }}
      >
        {/* Left indicator line */}
        <div
          style={{
            width: "6px",
            backgroundColor: line,
            borderTopLeftRadius: "0.75rem",
            borderBottomLeftRadius: "0.75rem"
          }}
        />

        {/* Card body */}
        <div className="card-body p-4 text-center d-flex flex-row w-100">
          {/* Title */}
          <div>
            <h4 className="fw-bold mb-0" style={{ fontSize: 28, color: text }}>
              Breach
            </h4>
            <div style={{ fontSize: 18, color: text }}>
              Probability
            </div>
          </div>

          {/* Score */}
          <div className="w-100 d-flex justify-content-end align-items-center">
            {renderScore({
              showScore: isValidScore || hasScore || hasMisconfig,
              score: score ?? '0',
              emptyText:
                "Start initial scanning to calculate breach probability.",
              color: text
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreachProbability;
